import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button'

// layout
import Layout from '../layout'

// store
import { Context } from '../store'
import types from '../store/types'

// styles
import { useStyles } from '../styles/common.style'

import { t } from 'application-translator/dist/translate/translate.react.js';

function NoBooking() {
  const classes = useStyles()

  // global state
  const { globalState, dispatch } = useContext(Context)
  const clubId = globalState.clubData.id

  // toggle workout
  const toggleWorkoutModal = () => {
    dispatch({ type: types.TOGGLE_WORKOUT_MODAL })
  }

  return (
    <Layout title={t('No booking Found')}>
      <div className={classes.content}>
        <p>{t("We can't ﬁnd a booking for that phone number at this club today.")}</p>
        <p>{t("Not a problem though;")}</p>

        <div className={classes.grp}>
          <Link
            to={`/links/${clubId}/enter-details`}
            className={classes.noDecor}
          >
            <Button
              variant="outlined"
              type="button"
              className={classes.buttonMod}
            >
              {t("Ready to train now?")}
            </Button>
          </Link>
          {/* @TODO toggle workout modal */}
          <Button
            variant="outlined"
            type="button"
            className={classes.buttonMod}
            onClick={toggleWorkoutModal}
          >
            {t('Book a workout for later')}
          </Button>
        </div>
      </div>
    </Layout>
  )
}

export default NoBooking
